<div class="modal-dialog modal-dialog-scrollable m-0 scrollable-dialog">
  <form class="kt-form w-webkit-fill-available" [formGroup]="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Request Receipt ({{ data.deposit.id }})</h5>
        <span class="modal-x-button" (click)="onCloseDialog()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      <div class="modal-body">
        <div class="row" [formGroup]="form">
          <div class="col-md-12 form-group">
            <label class="control-label">
              Remark (Internal) <span class="text-danger mr-1">*</span>
              <i
                class="fas fa-info-circle"
                matTooltipClass="custom-tooltip"
                matTooltipHideDelay="0"
                matTooltip="Internal remark for team use only and won't be visible to members."
                matTooltipPosition="above"
              >
              </i>
            </label>
            <input formControlName="remark" type="text" class="form-control" />
          </div>
          <div class="col-md-12 form-group">
            <label class="control-label">
              Reason (Member)
              <i
                class="fas fa-info-circle"
                matTooltipClass="custom-tooltip"
                matTooltipHideDelay="0"
                matTooltip="The reason to be displayed on the user portal, allowing members to understand why the receipt request action was taken."
                matTooltipPosition="above"
              >
              </i>
            </label>
            <input formControlName="reason" type="text" class="form-control" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCloseDialog()"><i class="fas fa-ban"></i>Close</button>
        <kt-submit-button [isDisabled]="!form.valid" [buttonLoading]="buttonLoading" (confirmed)="onSubmit()"></kt-submit-button>
      </div>
    </div>
  </form>
</div>

<kt-swal-alert [message]="messages$ | async" (confirmed)="onCloseDialog($event)"></kt-swal-alert>